import { render, staticRenderFns } from "./ViewPhysicians.vue?vue&type=template&id=5f0e4554&scoped=true&"
import script from "./ViewPhysicians.vue?vue&type=script&lang=js&"
export * from "./ViewPhysicians.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e4554",
  null
  
)

export default component.exports